module.exports = __webpack_public_path__ + "images/application/i-link-610aa24e.svg";